module.exports = __webpack_public_path__ + "img/Alchemist.449ab305.png";